module.exports = __webpack_public_path__ + "static/header-bannerbg-ironcapapi-min-abdfcc779b46bcef046b08b37ca8adf4.png";